<template>
  <div>
    <!-- <task-filter @change="onChange" /> -->
    <a-card size="small" :loading="loading">
      <a-page-header title="研发缺陷处理时长">
        <!-- <template slot="extra">
          <noticeboard-push v-has="{ code: 'data:noticeboard:push' }" :source-id="sourceId" :source-data="data" />
        </template> -->
      </a-page-header>
      <a-tabs v-model="activeKey" size="small">
        <a-tab-pane key="1" tab="缺陷处理时效">
          <a-card size="small" :loading="loading">
            <template slot="title">
              <span style="margin-right: 4px">表单说明</span>
              <a-popover title="报表说明" placement="topLeft">
                <template slot="content">
                  <p>离线表计算有t+1的数据延迟</p>
                  <p>缺陷统计范围不包括reject和duplicate状态的缺陷</p>
                  <p>统计区间为，缺陷首次处理完成时间在选择时间区间内，且缺陷已经处理完成</p>
                  <p>超时计算逻辑为，非生产缺陷p0，p1处理时长超过24h,p2，p3处理时长超过48h；生产缺陷p0，p1处理时长超过24h，生产缺陷p2，p3处理时长超过48h</p>
                  <p>p4级缺陷及以下暂不纳入统计范畴</p>
                  <p>加权缺陷总数 = 生产缺陷总数+ 非生产缺陷总数 + sum(1*2^n + 2*2^n + ... + n*2^n) n为reopen缺陷的次数</p>
                  <p>处理时长为缺陷创建时间～最后一次缺陷修复时间，处理时长过滤非工作时间</p>
                </template>
                <a-icon type="question-circle" />
              </a-popover>
              <span style="margin-right: 8px; margin-left: 8px">创建时间:</span>
              <a-range-picker v-model="timeList" :default-value="timeList" :allow-clear="false" @change="handleChange" />
            </template>
            <a-table size="small" :pagination="false" :columns="columns" row-key="index" :data-source="team_data" :loading="loading">
              <span slot="team_name" slot-scope="text, record">{{ record.team_name }} </span>
              <span slot="total" slot-scope="text, record" @click="onClick('total', record.source_id)">
                <span>{{ record.total }}</span>
              </span>
              <span slot="overtime" slot-scope="text, record" @click="onClick('overtime', record.source_id)">
                {{ record.overtime }}
              </span>
              <span slot="online_total" slot-scope="text, record" @click="onClick('online_total', record.source_id)">
                {{ record.online_total }}
              </span>
              <span slot="online_overtime" slot-scope="text, record" @click="onClick('online_overtime', record.source_id)">
                {{ record.online_overtime }}
              </span>
              <span slot="overtimeRate" slot-scope="text, record">
                <span v-if="record.actual_total != 0">{{ ((record.overtime / record.actual_total) * 100).toFixed(2) }}%</span>
                <span v-else>{{ '0.00%' }}</span>
              </span>

              <span slot="online_overtime_rate" slot-scope="text, record">
                <span v-if="record.online_total != 0">{{ ((record.online_overtime / record.online_total) * 100).toFixed(2) }}%</span>
                <span v-else>{{ '0.00%' }}</span>
              </span>
              <span slot="reopen_times" slot-scope="text, record" @click="onClick('reopen', record.source_id)">
                <span>{{ record.reopen_times }}</span>
              </span>
              <span slot="reopenRate" slot-scope="text, record">
                <span v-if="record.total != 0">{{ ((record.reopen_times / (record.total + record.online_total)) * 100).toFixed(2) }}%</span>
                <span v-else>{{ '0.00%' }}</span>
              </span>
            </a-table>
          </a-card>
        </a-tab-pane>
        <!-- <a-tab-pane :key="2" tab="任务排期量报表" :force-render="true">
            <task-point-trend :filter-form="filterForm" /> -->
        <!-- <work-info-detail-list style="float: left" :filter-form="filterForm" /> -->
        <!-- </a-tab-pane> -->
        <!-- <a-tab-pane :key="3" tab="按时完成率报表" :force-render="true">
            <task-point-trend :filter-form="filterForm" />
          </a-tab-pane> -->
      </a-tabs>
    </a-card>
    <div v-if="issueList && issueList.length > 0">
      <issue-solve-time-modal ref="taskListModal" :task-list="issueList" />
    </div>
  </div>
</template>
<script>
import { getDevWorkChart } from '@/api/data/noticeboard';
import { issueDevSolveTime } from '@/api/data/issue';
import moment from 'moment';
import IssueSolveTimeModal from '@/pages/data/components/IssueSolveTimeModal';

const columns = [
  {
    title: '名称',
    dataIndex: 'source_name',
    key: 'source_name',
    width: '10%',
    ellipsis: true,
    scopedSlots: { customRender: 'source_name' }
  },
  {
    title: '加权缺陷总数',
    dataIndex: 'total',
    key: 'total',
    width: '15%',
    sorter: (a, b) => a.total - b.total,
    scopedSlots: { customRender: 'total' },
    ellipsis: true
  },
  {
    title: '非生产缺陷总数',
    dataIndex: 'actual_total',
    key: 'actual_total',
    width: '15%',
    sorter: (a, b) => a.actual_total - b.actual_total,
    scopedSlots: { customRender: 'actual_total' },
    ellipsis: true
  },
  {
    title: '非生产环境超时修复',
    dataIndex: 'overtime',
    key: 'overtime',
    width: '15%',
    sorter: (a, b) => a.overtime - b.overtime,
    scopedSlots: { customRender: 'overtime' },
    ellipsis: true
  },
  {
    title: '非生产环境超时修复比例',
    dataIndex: 'overtimeRate',
    key: 'overtimeRate',
    width: '15%',
    sorter: (a, b) => a.overtime - b.overtime,
    scopedSlots: { customRender: 'overtimeRate' },
    ellipsis: true
  },
  {
    title: '生产缺陷总数',
    dataIndex: 'online_total',
    key: 'online_total',
    sorter: (a, b) => a.online_total - b.online_total,
    scopedSlots: { customRender: 'online_total' },
    width: '15%',
    ellipsis: true
  },
  {
    title: '生产缺陷超时解决数',
    dataIndex: 'online_overtime',
    key: 'online_overtime',
    width: '15%',
    ellipsis: true,
    scopedSlots: { customRender: 'online_overtime' }
  },
  {
    title: '生产缺陷超时解决比例',
    dataIndex: 'online_overtime_rate',
    key: 'online_overtime_rate',
    width: '15%',
    ellipsis: true,
    scopedSlots: { customRender: 'online_overtime_rate' }
  },
  {
    title: 'reopen次数',
    dataIndex: 'reopen_times',
    key: 'reopen_times',
    width: '15%',
    ellipsis: true,
    sorter: (a, b) => a.reopen - b.reopen,
    scopedSlots: { customRender: 'reopen_times' }
  },
  {
    title: 'reopen率',
    dataIndex: 'reopenRate',
    key: 'reopenRate',
    width: '15%',
    ellipsis: true,
    scopedSlots: { customRender: 'reopenRate' }
  }
];
export default {
  components: { IssueSolveTimeModal },
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns,
      loading: false,
      visible: false,
      activeKey: '1',
      issueList: [],
      taskData: {},
      taskList: [],
      create_begin_time: '',
      create_end_time: '',
      timeList: [],
      data: {
        title: null,
        projects: [],
        start_date: null,
        end_date: null,
        description: null,
        params: {}
      },
      formData: {},
      team_data: [],
      correctionData: []
    };
  },
  watch: {
    filterForm() {
      // console.log(this.filterForm);
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },

  methods: {
    handleChange() {
      console.log(this.timeList);
      if (this.timeList.length > 0) {
        this.filterForm.create_begin_time = moment(this.timeList[0]).format('YYYY-MM-DD');
        this.filterForm.create_end_time = moment(this.timeList[1]).format('YYYY-MM-DD');
      } else {
        this.filterForm.create_begin_time = null;
        this.filterForm.create_end_time = null;
      }
      this.getDiagramData();
    },
    onClick(type, source_id) {
      var filteredData = this.team_data.filter(function (item) {
        return item.source_id === source_id;
      });
      if (type === 'total') {
        this.issueList = filteredData[0].issue_list;
      }
      if (type === 'overtime') {
        this.issueList = filteredData[0].overtime_list;
      }
      if (type === 'online_overtime') {
        this.issueList = filteredData[0].online_overtime_list;
      }
      if (type === 'online_total') {
        this.issueList = filteredData[0].online_issue_list;
      }
      if (type === 'reopen') {
        this.issueList = filteredData[0].reopen_list;
      }
      // this.index = index;
      setTimeout(() => {
        this.$refs.taskListModal.open();
      }, 10); // 延迟 200 毫秒
    },
    getDiagramData() {
      this.loading = true;
      issueDevSolveTime({ ...this.filterForm })
        .then(res => {
          this.team_data = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-tbody > tr > td > p {
  padding: 8px;
  border-bottom: 1px solid #e8e8e8;
  line-height: 20px;
  margin: 0 -8px;
}

/deep/ .ant-table-tbody > tr > td > p:last-child {
  margin-bottom: -12px;
  border: 0;
}

/deep/ .ant-table-tbody > tr > td > p:first-child {
  margin-top: -8px;
}
/deep/.ant-page-header {
  padding: 0;
}

/deep/.ant-tabs-bar {
  margin: 0 0 12px 0;
}
</style>
